export function register() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register(`${process.env.PUBLIC_URL}/service-worker.js`)
        .then(() => console.log('Service Worker registered'))
        .catch(err => console.error('SW registration failed:', err));
    });
  }
}
